import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    login: {
        'title': 'Software system',
        'login': 'Login'
    },
    mBooking: {
        phone: 'MOBILE',
        phonePlace: 'Please input mobile',
        code: 'V.CODE',
        codePlace: 'Please input code',
        getCode: 'GET CODE',
        surplus: 'Surplus',
        name: 'NAME',
        namePlace: 'Please input name',
        gender: 'GENDER',
        genderPlace: 'Please select GENDER',
        man: 'Man',
        woman: 'Woman',
        unknow: 'Unknow',
        email: 'EMAIL',
        emailPlace: 'Please input email',
        branch: 'BRANCH',
        branchPlace: 'Please select branch',
        number: 'NUMBER',
        customer: 'CUSTOMER',
        date: 'DATE',
        datePlace: 'Please select date',
        time: 'TIME',
        timePlace: 'Please select time',
        service: 'SERVICE',
        servicePlace: 'Please pick SERVICE',
        select: 'Selected',
        sure: 'SURE',
        submit: 'SUBMIT',
        cancel: 'CANCEL',
        checkTel: 'Please enter the correct mobile phone number',
        checkMail: 'Please enter the correct mailbox',
        checkOrder: 'Please choose the reservation item!',
        viewMap: 'View Map',
        tips: 'Tips',
        datetime: 'Year month day hour minute',
        Year: 'Year',
        month: 'month',
        day: 'day',
        hour: 'hour',
        minute: 'minute',
    },
    ...enLocale
}
export default en